import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FixedAssetInitialRecognitionsDto } from "../../../../dtos/documents/FixedAssetInitialRecognitions/FixedAssetInitialRecognitionsDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "../../../Shared/NewForms/NFLookupWarehouse";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { FixedAssetInitialRecognitionsModel } from "../../../../models/Documents/FixedAssetInitialRecognitionsModel/FixedAssetInitialRecognitionsModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import { NFLookupExpenseItem } from "../../../Shared/NewForms/NFLookupExpenseItem";
import { NFLookupEmployee } from "../../../Shared/NewForms/NFLookupEmployee";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import FixedAssetInitialRecognitionsDetailSkeleton from "./FixedAssetInitialRecognitionsDetailSkeleton";
import { FixedAssetInitialRecognitionsDetailFooter } from "./FixedAssetInitialRecognitionsDetailFooter";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
interface IProps {
  model: FixedAssetInitialRecognitionsDto | null;
  modelUpdatedEvent: (newModel: FixedAssetInitialRecognitionsDto) => void;
}

// const resolver: Resolver<OpenBalanceOfGoodsDto> = async (values) => {
//     return {
//         values: values.documentNumber ? values : {},
//         errors: !values.documentNumber
//             ? {
//                 documentNumber: {
//                     type: 'required',
//                     message: 'This is required.',
//                 },
//             }
//             : {},
//     };
// };

export const FixedAssetInitialRecognitionsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<FixedAssetInitialRecognitionsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("fixedAssetInitialRecognitionGoods");
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Fixed Asset Initial Recognitions");

  useEffect(() => {
    console.log(model);
    register("fixedAssetInitialRecognitionGoods");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("companyId", model.companyId);
      setValue("kindOfExpenseCapitalizationDimension", model.kindOfExpenseCapitalizationDimension);
      setValue("address", model.address);
      setValue("accountingProcedure", model.accountingProcedure);
      setValue("createdDate", model.createdDate);
      setValue("usefulLife", model.usefulLife);
      setValue("financialAccountingGroup", model.financialAccountingGroup);
      setValue("expenseItem", model.expenseItem);
      setValue("divisionId", model.divisionId);
      setValue("responsibleEmployeeId", model.responsibleEmployeeId);
      setValue("fixedAssetInitialRecognitionGoods", model.fixedAssetInitialRecognitionGoods);
    }
  }, [model]);

  useEffect(() => {
    console.log(watchProducts);
  }, [watchProducts]);

  // const handleFormSubmit = (
  //   action: DocumentSaveActionType,
  //   data: FixedAssetInitialRecognitionsModel
  // ) => {
  //   console.log("form submit");
  //   console.log(data);
  //   console.log(action);
  //   if (action === "save") {
  //     const newModel: FixedAssetInitialRecognitionsDto = { ...model, ...data };
  //     console.log("new model");
  //     console.log(newModel);
  //     // if (modelUpdatedEvent) modelUpdatedEvent(newModel);
  //     saveHandler(newModel);
  //   } else if (action === "post") {
  //     postHandler();
  //   }
  // };

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: FixedAssetInitialRecognitionsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <FixedAssetInitialRecognitionsDetailSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.FixedAssetInitialRecognitions.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} />
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <NFTextInput fieldName={"address"} title={"address"} />
            </Col>
            <Col sm={6}>
              <NFIntInput fieldName={"accountingProcedure"} title={"accountingProcedure"} />
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <NFTextInput fieldName={"usefulLife"} title={"Useful life"} />
            </Col>
            <Col sm={6}>
              <NFTextInput fieldName={"financialAccountingGroup"} title={"Financial accounting group"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupExpenseItem fieldName={"expenseItem"} title={"Expense item"} />
            </Col>
            <Col sm={6}>
              <NFLookupDivision fieldName={"divisionId"} title={"Division"} companyId={watch("companyId")} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupEmployee fieldName={"responsibleEmployeeId"} title={"Responsible employee"} />
            </Col>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"fixedAssetInitialRecognitionGoods"}>
            <NFTextInput fieldName={"cost2"} title={"cost2"} />
            <NFTextInput fieldName={"cost1"} title={"cost1"} />
            <NFTextInput fieldName={"inventoryNumber"} title={"inventoryNumber"} />
          </NFormTable>
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <FixedAssetInitialRecognitionsDetailFooter />
    </FormProvider>
  );
};
